import { IAuthor } from '../interface/author.interface';
import { IPostCover, IResponseSimplifiedPost } from '../interface/post.interface';
import { IMonetisakuEnrollmentListItem } from '@data/interface/monetisaku.interface';

export class PostModel {
	_id: string;
	id: string;
	author: IAuthor;
	coverImage: string;
	coverCustom: IPostCover;
	title: string;
	category: string;
	genre: any[];
	postStatus: string;
	views: number;
	likes: number;
	bookmarks: number;
	share: number;
	createdAt: Date;
	updatedAt: Date;
	isMonetized: boolean;

	constructor() {
		this.id = '';
		this._id = '';
		this.author = {
			id: '',
			fullName: '',
			username: '',
			photoURL: ''
		};
		this.coverImage = '';
		this.coverCustom = {
			title: '',
			backgroundColor: '',
			backgroundUrl: '',
			fontSize: 1,
			color: ''
		};
		this.title = '';
		this.category = '';
		this.genre = [];
		this.postStatus = '';
		this.views = 0;
		this.likes = 0;
		this.bookmarks = 0;
		this.share = 0;
		this.createdAt = new Date();
		this.updatedAt = new Date();
		this.isMonetized = false;
	}

	static fromSimplifiedResponse(data: IResponseSimplifiedPost) {
		const postModel = new PostModel();
		postModel.id = data._id;
		postModel._id = data._id;
		postModel.author = data.author;
		postModel.coverImage = data.coverImage;
		postModel.coverCustom = data.coverCustom;
		postModel.title = data.title;
		postModel.category = data.category;
		postModel.genre = [];
		postModel.postStatus = 'PUBLISHED';
		postModel.views = data.views;
		postModel.likes = data.likes;
		postModel.bookmarks = data.bookmarks;
		postModel.share = data.share;
		postModel.createdAt = new Date();
		postModel.updatedAt = new Date();
		postModel.isMonetized = data.isMonetized;

		return postModel;
	}

	static fromMonetisakuEnrollmentListItem(data: IMonetisakuEnrollmentListItem) {
		const postModel = new PostModel();
		postModel.id = data.post._id;
		postModel._id = data.post._id;
		postModel.author = data.user;
		postModel.coverImage = data.post.coverImage;
		postModel.coverCustom = data.post.coverCustom ?? {
			title: '',
			backgroundColor: '',
			backgroundUrl: '',
			fontSize: 12
		};
		postModel.title = data.post.title;
		postModel.category = data.post.category;
		postModel.genre = data.post.genre;
		postModel.postStatus = 'PUBLISHED';
		postModel.views = data.post.views;
		postModel.likes = data.post.likes;
		postModel.bookmarks = data.post.bookmarks;
		postModel.share = data.post.share;
		postModel.createdAt = new Date();
		postModel.updatedAt = new Date();

		return postModel;
	}
}
